import { Component, OnInit } from '@angular/core';
import { WebNavbarComponent } from '../../web-components/web-navbar/web-navbar.component';
import { WebFooterComponent } from '../../web-components/web-footer/web-footer.component';

@Component({
    standalone: true,
    selector: 'app-cancellation-and-refund',
    templateUrl: './cancellation-and-refund.component.html',
    styleUrls: ['./cancellation-and-refund.component.css'],
    imports: [WebNavbarComponent, WebFooterComponent]
})
export class CancellationAndRefundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
